import { RefreshIcon } from "@heroicons/react/outline";
import CardTrend from "./CardTrend";

const Trend = () => {
  return (
    <div className="w-full border-t my-8">
      <div className="flex items-end space-x-3 py-5">
        <div class="h1-bold">Lagi trending, nih!</div>
        <RefreshIcon className="h-7 text-tokped_green cursor-pointer" />
        <p className="font-semibold text-tokped_green text-lg cursor-pointer hover:text-green-600">
          Muat Lainnya
        </p>
      </div>
      <div className="grid grid-flow-row-dense lg:grid-cols-4 gap-2">
        <CardTrend
          img="https://images.tokopedia.net/img/cache/200-square/product-1/2020/2/5/54489355/54489355_c04f8170-3c5b-42d3-9565-5abcb470229b_1000_1000.webp?ect=4g"
          title="Pasir Kucing"
          product="128rb"
        />
        <CardTrend
          img="https://images.tokopedia.net/img/cache/200-square/product-1/2020/2/5/54489355/54489355_c04f8170-3c5b-42d3-9565-5abcb470229b_1000_1000.webp?ect=4g"
          title="Pasir Kucing"
          product="128rb"
        />
        <CardTrend
          img="https://images.tokopedia.net/img/cache/200-square/product-1/2020/2/5/54489355/54489355_c04f8170-3c5b-42d3-9565-5abcb470229b_1000_1000.webp?ect=4g"
          title="Pasir Kucing"
          product="128rb"
        />
        <CardTrend
          img="https://images.tokopedia.net/img/cache/200-square/product-1/2020/2/5/54489355/54489355_c04f8170-3c5b-42d3-9565-5abcb470229b_1000_1000.webp?ect=4g"
          title="Pasir Kucing"
          product="128rb"
        />
        <CardTrend
          img="https://images.tokopedia.net/img/cache/200-square/product-1/2020/2/5/54489355/54489355_c04f8170-3c5b-42d3-9565-5abcb470229b_1000_1000.webp?ect=4g"
          title="Pasir Kucing"
          product="128rb"
        />
        <CardTrend
          img="https://images.tokopedia.net/img/cache/200-square/product-1/2020/2/5/54489355/54489355_c04f8170-3c5b-42d3-9565-5abcb470229b_1000_1000.webp?ect=4g"
          title="Pasir Kucing"
          product="128rb"
        />
        <CardTrend
          img="https://images.tokopedia.net/img/cache/200-square/product-1/2020/2/5/54489355/54489355_c04f8170-3c5b-42d3-9565-5abcb470229b_1000_1000.webp?ect=4g"
          title="Pasir Kucing"
          product="128rb"
        />
        <CardTrend
          img="https://images.tokopedia.net/img/cache/200-square/product-1/2020/2/5/54489355/54489355_c04f8170-3c5b-42d3-9565-5abcb470229b_1000_1000.webp?ect=4g"
          title="Pasir Kucing"
          product="128rb"
        />
      </div>
    </div>
  );
};

export default Trend;
